<template>
  <div class="main-layout">
    <div class="layout-section">
      <div class="title-section">
        <v-icon size="50" color="#4976bd">mdi-account-supervisor-circle</v-icon>
        {{ itemsUser.title }}
      </div>
      <div class="layout-box-summary">
        <div
          class="card-box-user"
          v-for="(user, idx) in itemsUser.item"
          :key="`${idx}-${user}`"
        >
          <div class="box-user">
            <div>
              <v-img
                style="width: 55px; height: 55px"
                :src="user.image"
              ></v-img>
            </div>
            <div style="text-align: end">
              <div class="box-title">{{ user.title }}</div>
              <div class="box-value">
                <v-progress-circular
                  v-if="loadingSummaryBox"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else> {{ itemSummary[user.key] }}</span>
              </div>
              <div class="box-unit">{{ user.unit }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <hr class="my-8 hr-style" />
    </div>
    <div class="layout-section">
      <div class="title-section">
        <v-icon size="50" color="#4976bd">mdi-monitor-dashboard</v-icon>
        {{ itemsFilm.title }}
      </div>
      <div class="layout-box-summary">
        <div
          class="card-box-film"
          v-for="(film, idx) in itemsFilm.item"
          :key="`${idx}-${film}`"
        >
          <div class="box-film">
            <div>
              <v-img
                style="width: 55px; height: 55px"
                :src="film.image"
              ></v-img>
            </div>
            <div style="text-align: end">
              <div class="box-title">{{ film.title }}</div>

              <div class="box-value">
                <v-progress-circular
                  v-if="loadingSummaryBox"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else> {{ itemSummary[film.key] }}</span>
              </div>
              <div class="box-unit">{{ film.unit }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loadingSummaryBox: false,
      itemSummary: {
        total_upload: 0,
        total_upload_confirm: 0,
        total_upload_pending: 0,
        total_user: 0,
        total_user_pending: 0
      },
      itemsUser: {
        title: 'ผู้ใช้งาน',
        item: [
          {
            image: require('@/assets/images/xraypage/userAll.png'),
            title: 'ผู้ใช้งานทั้งหมด',
            key: 'total_user',
            unit: 'คน'
          },
          {
            image: require('@/assets/images/xraypage/userWaitApprove.png'),
            title: 'ผู้ใช้งานรออนุมัติ',
            key: 'total_user',
            unit: 'คน'
          }
        ]
      },
      itemsFilm: {
        title: 'การใช้งาน',
        item: [
          {
            image: require('@/assets/images/xraypage/img_box_X-ray01.png'),
            title: 'รายการทั้งหมด',
            key: 'total_upload',
            unit: 'เคส'
          },
          {
            image: require('@/assets/images/xraypage/img_box_X-ray02.png'),
            title: 'รอยืนยันผล',
            key: 'total_upload_pending',
            unit: 'เคส'
          },
          {
            image: require('@/assets/images/xraypage/img_box_X-ray03.png'),
            title: 'ยืนยันผลวินิจฉัย',
            key: 'total_upload_confirm',
            unit: 'เคส'
          }
        ]
      }
    }
  },
  props: {
    hospital_id: {
      type: String
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      this.initHospitalStatus()
    },
    async initHospitalStatus () {
      const payload = {
        hospital_id: this.hospital_id
      }
      this.loadingSummaryBox = true
      const res = await this.getHospitalStatus(payload)
      this.loadingSummaryBox = false
      if (res.status) {
        this.itemSummary = res.data
      } else {
        this.antmessage.error(res.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-layout {
  // min-height: 100%;
  // background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
  border-radius: 12px;
  padding: 30px 20px 30px 20px;
  overflow-y: auto;
}
.layout-section {
  width: 100%;
}
.title-section {
  color: var(--v-textLandingPage-base) !important;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 20px;
}
.hr-style {
  border: #97b6e8 solid 1px;
}
.layout-box-summary {
  width: 100%;
  display: flex;
  // justify-content: space-between;
}
.card-box-user {
  width: 33.3%;
  // background-color: white;
  border-radius: 20px;
  padding: 0 10px 0 10px;
}
.box-user {
  width: 100%;
  display: flex;
  padding: 20px 20px 20px 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px;
  background-color: white;
  border-radius: 20px;
  align-items: center;
  justify-content: space-between;
}
.box-title {
  font-size: 20px;
  font-weight: 500;
}
.box-value {
  font-size: 30px;
  font-weight: 600;
  color: #3873d2;
}
.box-unit {
  font-size: 20px;
  font-weight: 500;
}

.card-box-film {
  width: 33.3%;
  // background-color: white;
  border-radius: 20px;
  padding: 0 10px 0 10px;
}
.box-film {
  width: 100%;
  display: flex;
  padding: 20px 20px 20px 20px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 4px;
  background-color: white;
  border-radius: 20px;
  align-items: center;
  justify-content: space-between;
}

@media screen and (max-width: 1263px) {
  .layout-box-summary {
    flex-wrap: wrap;
  }
  .card-box-user {
    width: 49%;
    margin: 10px 0 10px 0;
  }
  .card-box-film {
    width: 49%;
    margin: 10px 0 10px 0;
  }
}

@media screen and (max-width: 720px) {
  .card-box-user {
    width: 100%;
  }
  .card-box-film {
    width: 100%;
  }
}
</style>
